<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-cloud-upload-outline
      </v-icon> DigiBoard Images
    </h2>
    <br>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="showUploadForm = true"
        >
          Upload New
          <br>
        </v-btn>
      </v-col>
      <hr>
      <br>
      <div
        v-if="!isBoardImagesAvailable"
        class="no-file-alert"
      >
        <h4>
          No Images Found.
        </h4>
      </div>
      <div class="pa-4 text-center">
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <template v-for="(img, n) in boardImages">
            <v-col
              :key="n"
              cols="12"
              sm="3"
              md="3"
            >
              <v-hover v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 2"
                  class="mx-auto"
                  :class="{ 'on-hover': hover }"
                  color="#CFD8DC"
                >
                  <div v-if="isContentImgOrGif(img.content_type)">
                    <v-img
                      :src="getFilePath(img.file_path)"
                      :lazy-src="getFilePath(img.file_path)"
                      aspect-ratio="1"
                      width="100%"
                      height="180"
                      class="my-imag-style"
                      contain
                    >
                      <template #placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          />
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                  <div v-else>
                    <video
                      width="100%"
                      height="180"
                      controls
                    >
                      <source
                        :src="getFilePath(img.file_path)"
                        :lazy-src="getFilePath(img.file_path)"
                        type="video/mp4"
                      >
                    </video>
                  </div>
                  <v-fade-transition>
                    <v-overlay
                      v-if="hover"
                      absolute
                      color="#036358"
                    >
                      <v-col v-if="isContentImgOrGif(img.content_type)">
                        <v-icon
                          large
                          @click="showImg(img.file_path)"
                        >
                          mdi-image
                        </v-icon>
                      </v-col>
                      <v-col v-if="!isContentImgOrGif(img.content_type)">
                        <v-icon
                          large
                          @click="showVideo(img.file_path)"
                        >
                          mdi-video
                        </v-icon>
                      </v-col>
                      <v-col>
                        <v-icon
                          large
                          @click="deleteImage(img.unique_file_name)"
                        >
                          mdi-trash-can
                        </v-icon>
                      </v-col>
                    </v-overlay>
                  </v-fade-transition>
                  <br>
                  <div class="file-details">
                    <p class="my-p-style">
                      File Name:-
                      <font
                        class="font-my-style"
                      >
                        {{ img.original_file_name }}
                      </font>
                    </p>
                  </div>
                </v-card>
              </v-hover>
            </v-col>
          </template>
        </v-row>
      </div>
      <div class="py-3" />
    </v-card>
    <image-preview
      v-if="showPreview"
      :url="selectedLink"
      @closed="showPreview = false"
    />
    <video-preview
      v-if="showVideoPreview"
      :url="selectedVideoLink"
      @closed="showVideoPreview = false"
    />
    <upload-board-image
      v-if="showUploadForm"
      @success="onUploadSuccess"
      @closed="showUploadForm = false"
    />
    <delete-image
      v-if="showDelete"
      :title="'Delete Image?'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import UploadBoardImage from './UploadBoardImage.vue';
  import { cdnUrl } from 'src/app-globals';
  import ImagePreview from 'src/views/dashboard/component/ImagePreview.vue';
  import VideoPreview from 'src/views/dashboard/component/VideoPreview.vue';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';

  export default {
    name: 'WebhooksList',
    components: {
      'centre-spinner': spinner,
      'upload-board-image': UploadBoardImage,
      'image-preview': ImagePreview,
      'video-preview': VideoPreview,
      'delete-image': DeleteDialog,
      },
    data () {
      return {
        loading: false,
        showUploadForm: false,
        showPreview: false,
        selectedLink: null,
        showVideoPreview: false,
        selectedVideoLink: null,
        uniqueFileName: '',
        showDelete: false,
      };
    },
    computed: {
      boardImages () {
        return this.$store.getters['digiboards/getBoardImages'];
      },
      isBoardImagesAvailable () {
        if (this.boardImages.length > 0) {
            return true;
        }
        return false;
      },
      columnToDisplay () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return 3;
        } else {
          return 6;
        }
      },
    },
    async mounted () {
      await this.getBoardImages();
    },
    methods: {
      async getBoardImages () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        await this.$store.dispatch('digiboards/fetchBoardImages', {
          params: {
            categoryType: 'digi_board',
            digiBoardId: digiBoardId,
          },
        });
        this.loading = false;
      },
      isContentImgOrGif (contentType) {
        if (contentType === 'image' || contentType === 'gif') {
          return true;
        }
        return false;
      },
      getFilePath (fileName) {
        return `${cdnUrl}/${fileName}`;
      },
      showImg (link) {
        this.selectedLink = `${cdnUrl}/${link}`;
        this.showPreview = true;
      },
      showVideo (link) {
        this.selectedVideoLink = `${cdnUrl}/${link}`;
        this.showVideoPreview = true;
      },
      deleteImage (fileName) {
        this.uniqueFileName = fileName;
        this.showDelete = true;
      },
      async deleteConfirmed () {
        this.loading = true;
        this.showDelete = false;
        await this.$store.dispatch('digiboards/deleteBoardImage', {
          uniqueFileName: this.uniqueFileName,
        }).then(() => {
            this.getBoardImages();
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        });
      },
      onUploadSuccess () {
        this.showUploadForm = false;
        this.getBoardImages();
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-p-style {
    font-size: 16px;
    font-weight: bold;
    color: #546E7A;
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
    text-transform: capitalize;
}
.file-details {
  text-align: left;
  margin-left: 10px;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
}
.my-name-style {
  font-size: 16px;
  font-weight: bold;
  color:#37474F;
}
.my-description-style {
  font-weight: bold;
  color:#FF3700 !important;
}
.v-expansion-panels {
  z-index: 0;
}
.my-class {
  color:#37474F !important;
}
.no-file-alert {
  color: #C62828;
  font-size: 25px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  margin-bottom: 50px;
  margin-top: 50px;
}
.my-imag-style {
   background-color: #CFD8DC !important;
}
</style>
